import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
// @ts-ignore
import RetentionPartyMembership from '@/types/table/retentionPartyMembership';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface RetentionPartyMembershipData extends RetentionPartyMembership {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class RetentionPartyMembershipController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<RetentionPartyMembershipData>>(API_CONTEXT + '/app/retentionPartyMembership/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<RetentionPartyMembershipData>(API_CONTEXT + '/app/retentionPartyMembership/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/retentionPartyMembership/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/retentionPartyMembership/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/retentionPartyMembership/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/startOnly/flowRetentionPartyMembership', params, httpOptions);
  }
  static startWithBusinessKeyFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/startWithBusinessKey/flowRetentionPartyMembership', params, httpOptions);
  }
  static startAndTakeUserTaskFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/startAndTakeUserTask/flowRetentionPartyMembership', params, httpOptions);
  }
  static startAndSaveDraftFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/startAndSaveDraft/flowRetentionPartyMembership', params, httpOptions);
  }
  static submitUserTaskFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/submitUserTask/flowRetentionPartyMembership', params, httpOptions);
  }
  static viewTaskBusinessDataFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/retentionPartyMembership/viewTaskBusinessData/flowRetentionPartyMembership', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/retentionPartyMembership/viewHistoricTaskBusinessData/flowRetentionPartyMembership', params, httpOptions);
  }
  static listWorkOrderFlowRetentionPartyMembership(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/retentionPartyMembership/listWorkOrder/flowRetentionPartyMembership', params, httpOptions);
  }
  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<RetentionPartyMembershipData>>(API_CONTEXT + '/app/retentionPartyMembership/getUserInformation', params, httpOptions);
  }

  static print(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/retentionPartyMembership/print', params, httpOptions);
  }
   static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
